import $ from 'jquery';

$(function () {
    $('.prev-dc').one('click', function () {
        $(this).click(function () {
            return false;
        });
    });
});
